import React from 'react';
import Header from '@shared/header/header.container';
import ButtonsList from './buttons-list/buttons-list.container';
import DispatchPageComponents from './dispatch-page.components';
import Title from '../shared/title/title';
import useResponsiveLayout from '../../styles/responsive-layout.hook';
import MobileButtonsList from './mobile-buttons-list/mobile-buttons-list.container';

const { Container } = DispatchPageComponents;

const DispatchPageContent: React.FunctionComponent = () => {
  const { isMobile } = useResponsiveLayout();

  return (
    <>
      <Header type="support" />
      <Container>
        <Title text="dispatchPage.title" />
        {isMobile ? <MobileButtonsList /> : <ButtonsList />}
      </Container>
    </>
  );
};

export default DispatchPageContent;
